import { useCallback, useEffect, useState } from 'react';

type Props = {
  correct: string;
};

export default ({ correct }: Props) => {
  const [show, setShow] = useState(false);
  const [text, setText] = useState('Show');

  const toggleShow = useCallback(() => {
    setShow((v) => !v);
  }, []);

  useEffect(() => {
    setText(show ? 'Hide' : 'Show');
  }, [show]);

  return (
    <div className="correct">
      <button className="show-btn" type="button" onClick={toggleShow}>
        {text}
      </button>
      <span>Correct answer:</span>
      {show && <span className="c_text">{correct}</span>}
    </div>
  );
};
